export { globalPreload, load } from './hooks.mjs'
